import { render, staticRenderFns } from "./RequestApprovalDialog.vue?vue&type=template&id=e5345f6a&"
import script from "./RequestApprovalDialog.vue?vue&type=script&lang=js&"
export * from "./RequestApprovalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports